const noHeaderVariants = {
	CAMPAIGN: 'campaignPage',
};

export default noHeaderVariants;
